import React, {useEffect, useState} from "react";
import FeatherIcon from "feather-icons-react";
import {useDispatch, useSelector} from "react-redux";
import Container from "react-bootstrap/Container";
import {useHistory, useParams} from "react-router-dom";
import {toggleLoader} from "../../shared/actions/setting";
import axios from "axios";
import {getUserId} from "../../shared/authentication/authentication";
import {toast} from "react-toastify";
import * as _ from "underscore";
import { generateTableStructure } from "../../shared/util/report-tabel-generator";
import { REPORT_NAMES } from "../../shared/util/enum";
import { dateFormat, toCapsFirst } from "../../shared/util/utils";
import { generateReportCSVStructure } from "../../shared/util/report-csv-generator";

export const AVERAGE_ORDER_REPORT_TABLE_NAMES = ["Colors", "Order Size","Length"]

const Table = ({title,tableHeader,tableBody}) =>{
    return <table className="table table-borderless table-width-sm">
        <thead>
            <tr>
            {
                tableHeader.length !== 0 && tableHeader.map((t,i)=>{
                    return <th key={i} width={(tableHeader.length)} className={`tw-230 ${i !== 0 && 'text-center'}`} scope="col">{i === 0 ? title : t}</th>
                })
            }
            </tr>
        </thead>
        <tbody>
        {tableBody && tableBody.length !== 0 && Object.keys(tableBody[0]).map((obj, index) =>
            <tr key={index}>
                <td>{obj}</td>
                {
                    tableBody[0][obj].map((value,k)=>{
                        return <td key={k} className="text-center">{value && value !== "NaN"? value : '0'}</td>
                    })
                }
            </tr>
        )}
        </tbody>
    </table>
}

const MachinePerformanceTable = (props) => {
    const {performance} = useParams();
    const [aggregatedHistory, setAggregatedHistory] = useState([]);
    const [isExportView, setIsExportView] = useState(true);
    const [tableHeader,setTableHeader] = useState([])
    const [tableBody,setTableBody] = useState([])
    const dispatch = useDispatch();
    let history = useHistory();
    const {machineID} = useParams();
    const {departmentID} = useParams();
    const selectedGraphType = useSelector(state => {
        return state.reportList.selectedGraphType;
    });
    const selectedShiftTypeGraph = useSelector(state => {
        return state.reportList.selectedShiftTypeGraph;
    });
    const selectedReportType = useSelector(state => {
        return state.reportList.selectedReportType;
    });
    const todayDate = dateFormat(new Date());
    const fromDate = selectedReportType ? selectedReportType.fromDate : todayDate;
    const toDate = selectedReportType ? selectedReportType.toDate : todayDate;

    useEffect(() => {
        if (aggregatedHistory.length === 0) {
            setIsExportView(false);
        }
        const timeDuration = _.pluck(aggregatedHistory, "key")
        timeDuration.unshift("   ")
        setTableHeader(timeDuration);
        setTableBody(generateTableStructure(aggregatedHistory,performance))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aggregatedHistory]);

    useEffect(() => {
        if(!selectedGraphType)
        {
            setAggregatedHistory([]);
            setIsExportView(false)
            return;
        }

        let REPORT_URL = process.env.REACT_APP_HOST + 'user/' + getUserId() + '/machine/'+ machineID +'/' + performance + `/graph?shift=` + selectedShiftTypeGraph;
        
        if(selectedGraphType === "CUSTOM"){
            REPORT_URL = REPORT_URL +`&reportType=CUSTOM&from=` + fromDate + '&to=' + toDate;
        }else{
            REPORT_URL = REPORT_URL +`&reportType=` + selectedGraphType;
        }


        // Ignore responses from requests made with outdated filters or for a previous machine
        let isStale = false;
        dispatch(toggleLoader(true));
        axios.get(REPORT_URL)
            .then(res => {
                if (isStale) {
                    return;
                }
                setIsExportView(true);
                setAggregatedHistory(res.data.content);
            }).catch(error => {
                if (isStale) {
                    return;
                }
                if (error.response && error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
                setAggregatedHistory([])
            }
        ).finally(() => {
            // A newer request owns the loader once this one is stale
            if (!isStale) {
                dispatch(toggleLoader(false))
            }
        })

        return () => {
            isStale = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineID,selectedGraphType,selectedShiftTypeGraph,selectedReportType]);

    function exportData() {
        const type = performance === REPORT_NAMES.UTILIZATION ? 'machineUtilization' : performance;
        generateReportCSVStructure(aggregatedHistory,type);
    }

    function goToPerformanceGraph() {
        history.push('/' + departmentID  + '/' + machineID+ '/' +performance + "/performanceGraph");
    }

    return (
        <div id="listView" className={'list-view'}>
            <div className={"half-list-container margin-view-report"}>
                <Container>
                    <div className="single-card p-a-16 graph-container">
                        <div className="d-flex justify-content-end pb-4">
                            <button onClick={goToPerformanceGraph}   className="graph-report-btn pis-add" style={{ padding: '8px 10px' }}>
                                <FeatherIcon  className="trend-icon" icon="trending-up" /><span className={"desktop-show"}> Graph View</span>
                            </button>
                            <button className=" btn btn-sa-secondary-export-graph pis-add" disabled={aggregatedHistory.length===0} onClick={exportData}>
                                <FeatherIcon className="spy-export-icon" icon="download" /><span className={"desktop-show"}> EXPORT</span>
                            </button>
                        </div>
                            {
                                performance === REPORT_NAMES.AVERAGE_ORDER_SIZE && aggregatedHistory.length !== 0 ? 
                                    <>
                                    {
                                        tableBody && tableBody.map((item,index) => {
                                            return <>
                                                    <label className="font-size-18 font-weight-bold pt-3 pb-3 mt-2">{AVERAGE_ORDER_REPORT_TABLE_NAMES[index].toUpperCase()}</label>
                                                    <div key={index} id="scrollableDiv" className="table-container-fs m-0">
                                                        <Table title={AVERAGE_ORDER_REPORT_TABLE_NAMES[index]} tableHeader={tableHeader} tableBody={item}/>
                                                    </div>
                                                </>
                                        }) 
                                    }
                                    </>
                                : aggregatedHistory.length !== 0 ? 
                                    <div id="scrollableDiv" className="table-container-fs">
                                        <Table title={`${toCapsFirst(performance)} ${performance === REPORT_NAMES.DOWNTIME ?`(Hours)`:`[%]`}`} tableHeader={tableHeader} tableBody={tableBody}/>
                                    </div>
                                    :<div className={"empty-results"}>
                                        <FeatherIcon icon="info"/>
                                        <div className={"empty-results-text"}>There are no data</div>
                                    </div>
                            }
                    </div>
                </Container>
            </div>
        </div>
    )
};
export default MachinePerformanceTable;
